import { render, staticRenderFns } from "./DashboardTicketSales.vue?vue&type=template&id=7e827b50&"
import script from "./DashboardTicketSales.vue?vue&type=script&lang=js&"
export * from "./DashboardTicketSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports